/**
 * Public CMS API — pages (Terms / Privacy) + FAQs.
 *
 * Used by the marketing site's server components, so the calls go through
 * `api` which is just an axios client (Next.js fetches on the server during
 * SSR/SSG).
 */

import api from "./api";

export type CmsPage = {
  id: string;
  slug: string;
  title: string;
  body_html: string;
  is_published: boolean;
  updated_at: string;
};

export type Faq = {
  id: string;
  question: string;
  answer: string;
  sort_order: number;
  is_published: boolean;
};

export const cmsService = {
  getPage: async (slug: string): Promise<CmsPage> => {
    const { data } = await api.get<CmsPage>(`/cms/pages/${slug}`);
    return data;
  },

  listFaqs: async (): Promise<Faq[]> => {
    const { data } = await api.get<Faq[]>("/cms/faqs");
    return data;
  },
};
